// removed by extract-text-webpack-plugin
module.exports = {"container":"_3mJBf25TXxvpfaHHpNUi1O","callToAction":"_2c4d1Ckz_hXZjZ91FOkbiv","contact":"_2RlHa7bRDPq5rZDmOsBfr2","logos":"_11rjIi5AgCWDHF2ZAVFSQQ","logo":"_2w8e8EMw6ItFrn2WpvZ66X"};


//////////////////
// WEBPACK FOOTER
// ./src/sections/Footer.css
// module id = 173
// module chunks = 0